<!-- 
This component is made to avoid a double method call for the elapsed time value. 
This gets the calculated elapsed time only once, then applies updates and styles
according to its value. - Ryo
-->

<template>
  <span
    :class="'user-status-elapsed-time' + (isWarned === true ? ' caution' : '')"
  >
    {{ getFormattedElapsedTime }}
  </span>
</template>

<script>
const dateFormatLocale = 'fr-FR';

const elapsedTimeOptions = {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
};

export default {
  name: 'elapsed-time-display',

  props: {
    elapsedTime: {
      default: null,
      type: Number,
    },
    warn: {
      default: null,
      type: Boolean,
    },
  },

  computed: {
    getFormattedElapsedTime() {
      /*
        new Date() is set to UTC +1:00 while our elapsedTime is set to UTC +2:00.
        this raw substraction is only a temporary fix. - Ryo
      */
      if (this.elapsedTime > -1) {
        if (this.elapsedTime > 2592000000) {
          return '> 30j';
        }
        const formattedElapsedTime = new Date(this.elapsedTime);
        const tempHour = formattedElapsedTime.getHours();
        if (tempHour > 0) {
          formattedElapsedTime.setHours(formattedElapsedTime.getHours() - 1);
        } else {
          formattedElapsedTime.setHours(23);
        }
        return (
          (this.elapsedTime > 86400000
            ? formattedElapsedTime.getUTCDate() + 'j '
            : '') +
          formattedElapsedTime.toLocaleTimeString(
            dateFormatLocale,
            elapsedTimeOptions
          )
        );
      }
      return 'date départ introuvable';
    },

    isWarned() {
      // limit: 15 mins
      return (
        this.warn === true &&
        this.elapsedTime > process.env.VUE_APP_ESTIMATED_MAX_IMPORT_TIME_MS
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.user-status-elapsed-time {
  display: block;

  &.caution {
    color: red;
  }
}
</style>
